/* Fit Craver — free-shipping progress (bq-ship.js)
   Added 2026-09-05. Plan Part 4.2.

   Nothing in the cart told her how close she was to the ₪440 free-shipping
   threshold, so the automatic discount she already qualifies for was
   invisible. Shipping is ₪50-70 on a ₪250 product, and the second unit
   effectively costs her ₪200 instead of ₪250 once it triggers.

   Renders on the cart PAGE and inside the cart DRAWER, and re-reads the
   real cart every time either changes.
*/
(function () {
  'use strict';

  var THRESHOLD = 44000;   /* ₪440 in agorot — keep in step with the
                              "Free shipping above 2" automatic discount */

  var HE = (document.documentElement.lang || '').indexOf('he') === 0;

  function money(agorot) { return '₪' + Math.ceil(agorot / 100); }

  function remainingText(gap) {
    return HE
      ? 'נשארו <b>' + money(gap) + '</b> למשלוח חינם 🎁'
      : 'باقي <b>' + money(gap) + '</b> على التوصيل المجاني 🎁';
  }

  function wonText() {
    return HE
      ? '🎉 <b>המשלוח שלך חינם!</b>'
      : '🎉 <b>التوصيل مجاني!</b>';
  }

  function markup(subtotal) {
    var pct = Math.max(0, Math.min(100, Math.round(subtotal / THRESHOLD * 100)));
    var gap = THRESHOLD - subtotal;
    var won = gap <= 0;
    return '<div class="bq-ship__txt">' + (won ? wonText() : remainingText(gap)) + '</div>' +
           '<div class="bq-ship__track"><div class="bq-ship__fill' + (won ? ' is-won' : '') +
           '" style="width:' + pct + '%"></div></div>';
  }

  /* place the bar at the top of a container, or update it if already there */
  function paint(host, subtotal, cls) {
    if (!host) return;
    var bar = host.querySelector(':scope > .bq-ship');
    if (!bar) {
      bar = document.createElement('div');
      bar.className = 'bq-ship ' + cls;
      host.insertBefore(bar, host.firstChild);
    }
    bar.innerHTML = markup(subtotal);
  }

  var busy = false;
  function refresh() {
    if (busy) return;
    busy = true;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        busy = false;
        var subtotal = cart.items_subtotal_price;

        /* empty cart: nothing useful to promise */
        if (!cart.item_count) {
          var old = document.querySelectorAll('.bq-ship');
          for (var i = 0; i < old.length; i++) old[i].remove();
          return;
        }

        /* cart page */
        var page = document.querySelector('.t4s-cart-2column') ||
                   document.querySelector('form.t4s-cartPage__form');
        if (page) paint(page, subtotal, 'bq-ship--page');

        /* cart drawer */
        var mc = document.getElementById('t4s-mini_cart');
        if (mc) {
          var host = mc.querySelector('.t4s-drawer__content') || mc;
          paint(host, subtotal, 'bq-ship--drawer');
        }
      })
      .catch(function () { busy = false; });
  }

  function init() {
    refresh();

    /* the drawer and the cart page both re-render over ajax */
    if (window.MutationObserver) {
      var mc = document.getElementById('t4s-mini_cart');
      if (mc) {
        new MutationObserver(function () { refresh(); })
          .observe(mc, { childList: true, subtree: true,
                         attributes: true, attributeFilter: ['class'] });
      }
      var page = document.querySelector('form.t4s-cartPage__form');
      if (page) {
        new MutationObserver(function () { refresh(); })
          .observe(page, { childList: true, subtree: true });
      }
    }

    /* any add/remove/quantity change anywhere on the site */
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-quantity-selector], [data-remove-item], [data-atc-form], .bq-cross__btn')) {
        setTimeout(refresh, 700);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
})();
